<div class="container">

  <div class="flex-lg-row-reverse align-items-center py-5 row position-relative">
    <video autoplay muted playsinline id="myVideo" class="playing p-0" [muted]="true" [autoplay]="true" #videoElement
           (load)="videoElement.play()" (timeupdate)="(videoElement.duration - videoElement.currentTime) <= 3 ? document.getElementById('videotext')!.classList.remove('d-none') : ''">
      <source src="assets/videos/main.mp4" type="video/mp4">
    </video>
    <div class="videodiv text-center d-none fade-in" style="background-color: rgba(211,211,211,0.6); width: 100%; padding: 0" id="videotext">
      <img alt="iLogistix Logo" style="border-radius: 25px; height: 100px; width: 250px" height="316" ngSrc="assets/images/ilogistix-logo.png" width="788">
    </div>
  </div>
  <div class="row flex-lg-row-reverse align-items-center py-5 position-relative">
    <div class="col-10 col-sm-8 col-lg-6">
      <img ngSrc="assets/images/mainpage.jpg" class="d-block mx-lg-auto img-fluid"
           alt="" width="1024" height="683">
    </div>
    <div class="col-lg-6">
      <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">Finde deinen Traumjob!</h1>
      <p class="lead">Willkommen bei der iLogistix – Ihre erstklassigen Adresse für Zeitarbeit und
        Personalvermittlung!</p>
      <p class="lead"> Entdecken Sie mit uns die Zukunft der Arbeitswelt! Bei uns steht der Mensch im Mittelpunkt, und
        wir setzen alles daran, die perfekte Verbindung zwischen Unternehmen und Talenten herzustellen. Egal, ob Sie auf
        der Suche nach flexiblen Arbeitsmöglichkeiten oder qualifizierten Mitarbeitern sind – wir bieten
        maßgeschneiderte Lösungen, die auf Ihre individuellen Bedürfnisse zugeschnitten sind.</p>
      <p class="lead">
        Unser engagiertes Team aus erfahrenen Personalberatern arbeitet mit Leidenschaft daran, die besten Talente mit
        den spannendsten Unternehmen zusammenzubringen. Dabei legen wir großen Wert auf Transparenz, Fairness und
        Nachhaltigkeit. Ihre Zufriedenheit steht für uns an erster Stelle!
      </p>
      <p class="lead">
        Entdecken Sie neue berufliche Perspektiven oder optimieren Sie Ihr Team mit uns an Ihrer Seite. Durchsuchen Sie
        unsere aktuellen Stellenangebote oder kontaktieren Sie uns direkt, um Ihre individuellen Anforderungen zu
        besprechen.
      </p>
      <p class="lead">
        Mit uns gehen Sie einen Schritt voraus – für eine erfolgreiche Zukunft im dynamischen Arbeitsmarkt!
      </p>
      <a routerLink="/jobsuche">
        <button class="btn btn-primary btn-lg mt-1" style="width: auto">Zur Jobsuche</button>
      </a>
    </div>
  </div>
</div>

<div class="album py-5 bg-body-tertiary mb-1">

  <div class="text-center pb-3">
    <h3>Jobs filtern nach:</h3>
  </div>

  <div class="container">
    <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">

      <!-- TODO Verlinkungsfilter anpassen -->

      <div class="col">
        <div style="border-radius: 10px;" class="shadow-sm pointer" routerLink="/jobsuche" [queryParams]="{industry: 'kaufmaennisch'}">
          <!--suppress AngularNgOptimizedImage -->
          <img class="card-img-top w-100" style="height: 225px"
               src="assets/images/jobs/kaufmaennische_jobs.jpg" alt="Job Bild"/>
          <div style="border-radius: 0 0 10px 10px; background-color: #dc3545" class="card-body">
            <p class="text-white fw-bold text-center fs-5">Kaufmännische Jobs</p>
          </div>
        </div>
      </div>

      <div class="col">
        <div style="border-radius: 10px;" class="shadow-sm pointer" routerLink="/jobsuche" [queryParams]="{remote: 'yes'}">
          <!--suppress AngularNgOptimizedImage -->
          <img class="card-img-top w-100" style="height: 225px"
               src="assets/images/jobs/remote.jpg" alt="Job Bild"/>
          <div style="border-radius: 0 0 10px 10px; background-color: #dc3545" class="card-body">
            <p class="text-white fw-bold text-center fs-5">Remote</p>
          </div>
        </div>
      </div>

      <div class="col">
        <div style="border-radius: 10px;" class="shadow-sm pointer" routerLink="/jobsuche" [queryParams]="{education: 'displ_ingenieure'}">
          <!--suppress AngularNgOptimizedImage -->
          <img class="card-img-top w-100" style="height: 225px"
               src="assets/images/jobs/jobs_fuer_dipl_ingenieure.jpg" alt="Job Bild"/>
          <div style="border-radius: 0 0 10px 10px; background-color: #dc3545" class="card-body">
            <p class="text-white fw-bold text-center fs-5">Jobs für Dipl. Ingenieure</p>
          </div>
        </div>
      </div>

      <div class="col">
        <div style="border-radius: 10px;" class="shadow-sm pointer" routerLink="/jobsuche" [queryParams]="{industry: 'handwerk_commercial'}">
          <!--suppress AngularNgOptimizedImage -->
          <img class="card-img-top w-100" style="height: 225px"
               src="assets/images/jobs/handwerk_gewerbliche_jobs.jpg" alt="Job Bild"/>
          <div style="border-radius: 0 0 10px 10px; background-color: #dc3545" class="card-body">
            <p class="text-white fw-bold text-center fs-5">Handwerk - Gewerbliche Jobs</p>
          </div>
        </div>
      </div>

      <div class="col">
        <div style="border-radius: 10px;" class="shadow-sm pointer" routerLink="/jobsuche" [queryParams]="{education: 'uneducated'}">
          <!--suppress AngularNgOptimizedImage -->
          <img class="card-img-top w-100" style="height: 225px"
               src="assets/images/jobs/ungelernte_jobs.jpg" alt="Job Bild"/>
          <div style="border-radius: 0 0 10px 10px; background-color: #dc3545" class="card-body">
            <p class="text-white fw-bold text-center fs-5">Ungelernte Jobs</p>
          </div>
        </div>
      </div>

      <div class="col">
        <div style="border-radius: 10px;" class="shadow-sm pointer" routerLink="/jobsuche">
          <!--suppress AngularNgOptimizedImage -->
          <img class="card-img-top w-100" style="height: 225px"
               src="../../../../assets/images/jobs/alle_berufsfelder.jpg" alt="Job Bild"/>
          <div style="border-radius: 0 0 10px 10px; background-color: #dc3545" class="card-body">
            <p class="text-white fw-bold text-center fs-5">Alle Berufe</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
